<template>
    <header class="app-header navbar">
        <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
            <span class="navbar-toggler-icon"></span>
        </button>
        <b-link class="navbar-brand" to="#"></b-link>
        <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
            <span class="navbar-toggler-icon"></span>
        </button>
        <b-nav is-nav-bar class="d-md-down-none">
            <!-- <b-nav-item class="px-3">dropdown-1</b-nav-item>
            <b-nav-item class="px-3">dropdown-2</b-nav-item>
            <b-nav-item class="px-3">dropdown-3</b-nav-item> -->
        </b-nav>
        <b-nav is-nav-bar class="ml-auto">
            <HeaderDropdown/>
        </b-nav>
        <!-- <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
            <span class="navbar-toggler-icon"></span>
        </button> -->
    </header>
</template>

<script>
import HeaderDropdown from './HeaderDropdown';

export default {
    name: 'header',
    components: {
        HeaderDropdown,
    },
    methods: {
        sidebarToggle (e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-hidden');
        },
        sidebarMinimize (e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-minimized');
        },
        mobileSidebarToggle (e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-mobile-show');
        },
        asideToggle (e) {
            e.preventDefault();
            document.body.classList.toggle('aside-menu-hidden');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/nav_components/Header.vue